import type { SVGProps } from "react";

export const SkippedDirectionArrow = (props: SVGProps<SVGSVGElement>) => {
  const { color = "#C5C6C9", ...otherProps } = props;

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <path
        d="M10.0002 15.8337C9.30572 15.8337 8.71544 15.5906 8.22933 15.1045C7.74322 14.6184 7.50016 14.0281 7.50016 13.3337C7.50016 12.6392 7.74322 12.0489 8.22933 11.5628C8.71544 11.0767 9.30572 10.8337 10.0002 10.8337C10.6946 10.8337 11.2849 11.0767 11.771 11.5628C12.2571 12.0489 12.5002 12.6392 12.5002 13.3337C12.5002 14.0281 12.2571 14.6184 11.771 15.1045C11.2849 15.5906 10.6946 15.8337 10.0002 15.8337ZM3.396 10.0003C3.59044 8.34755 4.31266 6.96213 5.56266 5.84408C6.81266 4.72602 8.28488 4.16699 9.97933 4.16699C10.9932 4.16699 11.9307 4.37185 12.7918 4.78158C13.6529 5.1913 14.3891 5.75033 15.0002 6.45866V4.16699H16.6668V10.0003H10.8335V8.33366H14.3335C13.8891 7.58366 13.2884 6.97949 12.5314 6.52116C11.7745 6.06283 10.9307 5.83366 10.0002 5.83366C8.77794 5.83366 7.70155 6.22949 6.771 7.02116C5.84044 7.81283 5.27794 8.80588 5.0835 10.0003H3.396Z"
        fill={color}
      />
    </svg>
  );
};
